const MAX_EVENT_WIDTH = 400
const DEFAULT_EVENT_WIDTH = 256
const DEFAULT_EVENT_HEIGHT = 192

export function useEventImageStyle () {
  const getEventImageStyle = (event) => {
    if (!event?.image_crop_dimensions) {
      return {
        aspectRatio: `${DEFAULT_EVENT_WIDTH / DEFAULT_EVENT_HEIGHT}`,
        objectFit: 'cover',
        objectPosition: 'center center'
      }
    }
    
    const { width, height } = event.image_crop_dimensions
    if (width === 0 || height === 0) {
      return {
        aspectRatio: `${DEFAULT_EVENT_WIDTH / DEFAULT_EVENT_HEIGHT}`,
        objectFit: 'cover',
        objectPosition: 'center center'
      }
    }
    
    const aspectRatio = width / height
    return {
      aspectRatio: `${aspectRatio}`,
      objectFit: 'cover',
      objectPosition: 'center center',
      maxWidth: '100%',
      height: 'auto'
    }
  }

  const getEventImageContainerStyle = (event, maxWidth = null) => {
    if (!event?.image_crop_dimensions) {
      const containerMaxWidth = maxWidth || DEFAULT_EVENT_WIDTH
      return {
        width: '100%',
        maxWidth: `${containerMaxWidth}px`,
        aspectRatio: `${DEFAULT_EVENT_WIDTH / DEFAULT_EVENT_HEIGHT}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }
    }
    
    const { width, height } = event.image_crop_dimensions
    if (width === 0 || height === 0) {
      const containerMaxWidth = maxWidth || DEFAULT_EVENT_WIDTH
      return {
        width: '100%',
        maxWidth: `${containerMaxWidth}px`,
        aspectRatio: `${DEFAULT_EVENT_WIDTH / DEFAULT_EVENT_HEIGHT}`,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden'
      }
    }

    const effectiveMaxWidth = maxWidth || MAX_EVENT_WIDTH
    const aspectRatio = width / height

    return {
      width: '100%',
      maxWidth: `${effectiveMaxWidth}px`,
      aspectRatio: `${aspectRatio}`,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      overflow: 'hidden'
    }
  }

  return {
    getEventImageStyle,
    getEventImageContainerStyle
  }
}

